module.exports = __webpack_public_path__ + "img/four4Red.4cba8065.png";